import React from 'react';
import { AlertTriangle, Loader2, Trash2 } from 'lucide-react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter,
  DialogHeader, DialogTitle, DialogTrigger
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export default function DeleteOrgDialog({
  open,
  onOpenChange,
  orgName,
  userCount,
  confirmText,
  setConfirmText,
  onDelete,
  deleting,
}) {
  const canDelete = !deleting && confirmText === orgName;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button variant="destructive" size="sm" data-testid="delete-org-btn">
          <Trash2 size={14} className="mr-1" /> Delete Organization
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-rose-600 flex items-center gap-2">
            <AlertTriangle size={20} /> Delete Organization
          </DialogTitle>
          <DialogDescription className="text-left pt-2 space-y-3">
            <p>
              You are about to permanently delete <strong>{orgName}</strong>. This action:
            </p>
            <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
              <li>Deactivates the organization and all its data</li>
              <li>Revokes access for <strong>{userCount} user(s)</strong> in this org</li>
              <li>Removes all role assignments tied to this organization</li>
              <li>Associated LEI, KPI, cohort, and program data will become inaccessible</li>
            </ul>
            <p className="text-sm font-medium pt-2">
              Type the organization name to confirm:
            </p>
            <Input
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder={orgName}
              data-testid="delete-org-confirm-input"
            />
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={() => { onOpenChange(false); setConfirmText(''); }}
            data-testid="delete-org-cancel-btn"
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onDelete}
            disabled={!canDelete}
            data-testid="delete-org-confirm-btn"
          >
            {deleting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Trash2 size={14} className="mr-1" />}
            Delete Organization
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
